
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Button } from "@/components/ui/button";
import { useLaunchDataQueries } from "./edit-launch-dialog/LaunchDataQueries";
import { useLaunchForm } from "./edit-launch-dialog/useLaunchForm";
import { LaunchForm } from "./edit-launch-dialog/LaunchForm";
import { FormValuesEdit } from "../types";
import { Form } from "@/components/ui/form";

interface EditLaunchDialogProps {
  isOpen: boolean;
  onClose: () => void;
  launchId: number;
}

const EditLaunchDialog = ({
  isOpen,
  onClose,
  launchId,
}: EditLaunchDialogProps) => {
  const { launch, isLoadingLaunch, formMappings, clients, templates } =
    useLaunchDataQueries(launchId, isOpen);

  const { form, isLoading, handleSubmit } = useLaunchForm(launchId, launch, onClose);

  // Create a wrapper function to handle the form submission
  const onSubmit = (data: FormValuesEdit) => {
    handleSubmit(data);
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-2xl max-h-[90vh] p-0 w-full max-w-[95vw] overflow-hidden flex flex-col">
        <div className="px-6 pt-6 pb-4">
          <DialogHeader>
            <DialogTitle>Editar Lanzamiento</DialogTitle>
            <DialogDescription>
              Actualiza la información del lanzamiento.
            </DialogDescription>
          </DialogHeader>
        </div>

        {isLoadingLaunch ? (
          <div className="flex items-center justify-center h-40">
            <p>Cargando...</p>
          </div>
        ) : (
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col flex-1 min-h-0">
              <div className="flex-1 overflow-y-auto px-6 min-h-0">
                <LaunchForm
                  form={form}
                  isLoading={isLoading}
                  formMappings={formMappings}
                  clients={clients}
                  templates={templates}
                  onSubmit={onSubmit}
                  onClose={onClose}
                />
              </div>
              <div className="px-6 py-4 border-t mt-auto flex-shrink-0">
                <div className="flex justify-end space-x-2">
                  <Button
                    type="button"
                    variant="outline"
                    onClick={onClose}
                    disabled={isLoading}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? "Actualizando..." : "Actualizar"}
                  </Button>
                </div>
              </div>
            </form>
          </Form>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default EditLaunchDialog;
